const singletonCodec = {
    encode: JSON.stringify,
    decode: JSON.parse,
};
export function standardJsonCodec() {
    return singletonCodec;
}
//# sourceMappingURL=json.js.map